










import questComponent from '@/components/polls/CreateForm/quest.vue'
import Vue from 'vue'
export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    questComponent
  }
})
